export function waitFor(
  condition: () => boolean,
  numOfTries = 10,
  interval = 50,
): Promise<void> {
  return new Promise((resolve, reject) => {
    let tries = 0;
    const intervalId = setInterval(() => {
      if (condition()) {
        clearInterval(intervalId);
        resolve();
      }
      if (tries++ > numOfTries) {
        clearInterval(intervalId);
        reject();
      }
    }, interval);
  });
}
